import React from 'react';
import Tooltip from 'components/Tooltip';
import { DeleteOutlined } from '@ant-design/icons';
import Input from 'components/forms/Input';
import InputLabel from '../common/InputLabel';
import OutputLabel from '../common/OutputLabel';
import FormRow from './FormRow';
import PercentageSelect from './PercentageSelect';

const InputWithSelectRow = ({
    editableTitle = false,
    title,
    currency,
    onChangeTitle = null,
    grossValue,
    onChangeGrossValue,
    hideSelect = false,
    percentage = null,
    onChangeFieldPercentage = null,
    netValue = null,
    showDeleteIcon = false,
    removeItem = null,
    selectStyles = {},
}) => (
    <FormRow style={{ display: 'flex', alignItems: 'center' }}>
        {editableTitle ? (
            <Input
                placeholder="Other"
                value={title}
                onChange={(event) => onChangeTitle(event.target.value)}
                className="occCost-form-text"
            />
        ) : (
            <InputLabel text={title} />
        )}
        <Input
            type="number"
            value={grossValue}
            onChange={(event) => onChangeGrossValue(event.target.value)}
            placeholder="0"
            size="large"
            style={{ borderRadius: '0.2em' }}
            className="occCost-form-number"
            addonBefore={currency}
        />
        {!hideSelect && (
            <>
                <PercentageSelect
                    selectedOption={percentage}
                    handleChange={onChangeFieldPercentage}
                    selectStyles={selectStyles}
                />
                <OutputLabel text={`${currency}${netValue}`} />
            </>
        )}
        {showDeleteIcon && (
            <Tooltip title="Warning - this will remove this item" placement="right">
                <DeleteOutlined onClick={removeItem} />
            </Tooltip>
        )}
    </FormRow>
);

export default InputWithSelectRow;
